const Themes = {
    namespaced: true,
    state: {
        all: [],
        current: null,
    },
    getters: {
        allThemes: (state) => {
            return state.all;
        },
        currentTheme: (state) => {
            return state.current;
        },
    },
    mutations: {
        SET_CURRENT_THEME(state, themeId) {
            state.current = themeId;
        },
        SET_ALL_THEME(state, themes) {
            state.all = themes;
        },
    },
    actions: {
        setCurrentTheme({ commit }, themeId) {
            commit('SET_CURRENT_THEME', themeId);
        },
        setAllTheme({ commit }, themes) {
            commit('SET_ALL_THEME', themes);
        },
    },
};

export default Themes;
